function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { PureComponent } from "react";
import isPlainObject from "./utils/isPlainObject";
import shallowEqual from "./utils/shallowEqual";
import bindActionCreators from "./bindActionCreators";
import { Context } from "./store";
/**
 * `connect` is a HOC which connects a React Component to the Redhooks store.
 * It returns a connected component that wraps the component you passed
 * in taking care to avoid unnecessary re-rendering. It should be used if your
 * class or function components perform an expensive rendering operation.
 *
 * @param {Function} mapStateToProps if passed, your component will be subscribed to Redhooks store.
 * @param {Function|Object} mapDispatchToProps - if passed must return a plain object whose values are
 * functions and whose props will be merged in your component’s props
 *
 * @returns {Component} It returns a connected component.
 */

var _mock = {};

var _mapStateToProps = function _mapStateToProps() {
  return _mock;
};

var _mapDispatchToProps = function _mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

export default (function (mapStateToProps, mapDispatchToProps) {
  if (mapStateToProps === void 0) {
    mapStateToProps = _mapStateToProps;
  }

  if (mapDispatchToProps === void 0) {
    mapDispatchToProps = _mapDispatchToProps;
  }

  if (mapStateToProps === null) {
    mapStateToProps = _mapStateToProps;
  }

  if (typeof mapStateToProps !== "function") {
    throw new Error(errMsg("mapStateToProps", mapStateToProps, "must be a function"));
  }

  if (isPlainObject(mapDispatchToProps)) {
    mapDispatchToProps = bindFunctionActions(mapDispatchToProps);
  }

  if (typeof mapDispatchToProps !== "function") {
    throw new Error(errMsg("mapDispatchToProps", mapDispatchToProps, "must be a function"));
  }

  return function (Comp) {
    var _temp;

    return _temp =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(Connect, _PureComponent);

      function Connect() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_innerState", {
          changeMapProp: false,
          prevMapPropChange: false,
          changeOwnProp: false,
          prevOwnPropsChange: false,
          prevMapProps: {},
          prevOwnProps: _this.props
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_render", function (value) {
          var state = value.state,
              dispatch = value.dispatch;
          var propsMapped = mapStateToProps(state, _this.props); // const propsMapped = {...this.props, ...propsMapped1};

          if (!isPlainObject(propsMapped)) {
            throw new Error(errMsg("mapStateToProps", propsMapped, "must return a plain object", Comp.name));
          }

          if (!_this._dispatchProps) {
            var propsDispatch = mapDispatchToProps(dispatch, _this.props);

            if (!isPlainObject(propsDispatch)) {
              throw new Error(errMsg("mapDispatchToProps", propsDispatch, "must return a plain object", Comp.name));
            }

            _this._dispatchProps = Object.keys(propsDispatch).length > 0 ? propsDispatch : {
              dispatch: dispatch
            };
          }

          _this._innerState.changeMapProp = shallowEqual(propsMapped, _this._innerState.prevMapProps) ? _this._innerState.changeMapProp : !_this._innerState.changeMapProp;
          _this._innerState.changeOwnProp = shallowEqual(_this.props, _this._innerState.prevOwnProps) ? _this._innerState.changeOwnProp : !_this._innerState.changeOwnProp;
          _this._innerState.prevMapProps = propsMapped;
          _this._innerState.prevOwnProps = _this.props;

          if (_this._innerState.prevMapPropChange !== _this._innerState.changeMapProp || _this._innerState.prevOwnPropsChange !== _this._innerState.changeOwnProp || !_this._wrapper) {
            _this._innerState.prevMapPropChange = _this._innerState.changeMapProp;
            _this._innerState.prevOwnPropsChange = _this._innerState.changeOwnProp;
            _this._wrapper = React.createElement(Comp, _extends({}, _this.props, propsMapped, _this._dispatchProps));
          }

          return _this._wrapper;
        });

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.render = function render() {
        return React.createElement(Context.Consumer, null, this._render);
      };

      return Connect;
    }(PureComponent), _temp;
  };
});

function bindFunctionActions(mapDispatchToProps) {
  return function (dispatch) {
    return bindActionCreators(_extends({}, mapDispatchToProps), dispatch);
  };
}

function errMsg(nameFN, prop, addText, displyName) {
  if (displyName === void 0) {
    displyName = "";
  }

  return nameFN + "() in Connect(" + displyName + ") " + addText + ". Instead received " + typeof prop + " => " + prop + ".";
}